import type { PDFDocumentProxy } from 'pdfjs-dist';

type PdfjsLib = typeof import('pdfjs-dist');

/** Ersatzschriften, CMaps, WASM-Decoder und ICC-Profile, siehe pdfjsAssetsPlugin in vite.config.ts. */
const PDFJS_ASSET_URL = `${import.meta.env.BASE_URL}${__PDFJS_ASSET_BASE__}/`;

let pdfjsLoader: Promise<PdfjsLib> | null = null;

export function loadPdfjs(): Promise<PdfjsLib> {
  if (!pdfjsLoader) {
    pdfjsLoader = Promise.all([
      import('pdfjs-dist'),
      import('pdfjs-dist/build/pdf.worker.min.mjs?url'),
    ]).then(([pdfjs, worker]) => {
      pdfjs.GlobalWorkerOptions.workerSrc = worker.default;
      return pdfjs;
    });
  }
  return pdfjsLoader;
}

export async function openPdfDocument(bytes: Uint8Array): Promise<PDFDocumentProxy> {
  const pdfjs = await loadPdfjs();
  return pdfjs.getDocument({
    data: bytes.slice(),
    // Nicht eingebettete Schriften (z. B. Arial in Fremd-PDFs) immer aus den mitgelieferten
    // Ersatzschriften rendern. Mit Systemschriften lädt pdf.js die Schriftdaten gar nicht erst
    // und staucht die Glyphen auf die Zeichenbreiten aus dem PDF.
    useSystemFonts: false,
    standardFontDataUrl: `${PDFJS_ASSET_URL}standard_fonts/`,
    cMapUrl: `${PDFJS_ASSET_URL}cmaps/`,
    cMapPacked: true,
    wasmUrl: `${PDFJS_ASSET_URL}wasm/`,
    iccUrl: `${PDFJS_ASSET_URL}iccs/`,
  }).promise;
}
